export default {
  data() {
    return {
      defaultMaxLength: 50
    }
  }
}
